export const DISCO_CODE = [
  'ABUJA',
  'EKO',
  'IKEJA',
  'IBADAN',
  'ENUGU',
  'PH',
  'JOS',
  'KADUNA',
  'KANO',
  'BH',
  'PROTOGY',
  'PHISBOND',
  'ACCESSPOWER',
  'YOLA',
  'ABIA',
  'ADAMAWA',
  'AKWA IBOM',
  'ANAMBRA',
  'BAUCHI',
  'BAYELSA',
  'BENUE',
  'BORNO',
  'CROSS RIVER',
  'DELTA',
  'EBONYI',
  'EDO',
  'EKITI',
  'GOMBE',
  'IMO',
  'JIGAWA',
  'KATSINA',
  'KEBBI',
  'KOGI',
  'KWARA',
  'LAGOS',
  'NASSARAWA',
  'NIGER',
  'OGUN',
  'ONDO',
  'OSUN',
  'OYO',
  'PLATEAU',
  'RIVERS',
  'SOKOTO',
  'TARABA',
  'YOBE',
  'ZAMFARA',
  'FCT',
];
